export const manifesto = [
    {
        number: "01",
        title: "The Collapse",
        body:
            "Twelve years of building — gone in a season. When the business fell apart, so did the map I thought I was following. There was no plan B, only the ground floor and a promise I refused to break.",
    },

    {
        number: "02",
        title: "The Lifeline",
        body:
            "Technology stopped being a hobby and became oxygen. Every stream, every line of code, every late night learning something new was a rung on the ladder back up. Not a comeback story yet — a comeback in progress.",
    },

    {
        number: "03",
        title: "The Promise",
        body:
            "This is for Mack, my best friend, and for everyone rebuilding quietly in the dark. Every follow, like, share and comment is fuel. You are not watching a channel — you are part of the climb.",
    },
];